import type { PropsWithChildren } from 'react';
import { useCallback, useEffect } from 'react';

import FocusLock from 'react-focus-lock';

interface FocusLockAndEscapeProps {
  handleEscapePressed: () => void;
}

export const FocusLockAndEscape = ({ children, handleEscapePressed }: PropsWithChildren<FocusLockAndEscapeProps>) => {
  const escFunction = useCallback(
    event => {
      if (event.key === 'Escape') {
        handleEscapePressed();
      }
    },
    [handleEscapePressed]
  );

  useEffect(() => {
    document.addEventListener('keydown', escFunction, false);

    return () => {
      document.removeEventListener('keydown', escFunction, false);
    };
  }, [escFunction]);
  return <FocusLock noFocusGuards={true}>{children}</FocusLock>;
};
